import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export function LoanOfficerHero() {
  return <div className="bg-white" data-id="element-88">
      {/* Top Brand Bar */}
      <div className="border-b border-gray-200" data-id="element-89">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-90">
          <span className="text-xl md:text-2xl font-bold text-brand tracking-tight" data-id="element-91">
            Rapid Home Lending Inc
          </span>
          <div className="flex items-center gap-4" data-id="element-92">
            <span className="text-lg font-semibold text-brand" data-id="element-93">
              Hello, Michael
            </span>
            <div className="hidden sm:flex items-center gap-2 text-sm text-brand-muted" data-id="element-94">
              <Phone className="w-4 h-4" data-id="element-95" />
              <a href="tel:+12485379200" className="hover:text-brand transition-colors font-medium" data-id="element-96">
                (248) 537-9200
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Cover Strip */}
      <div className="h-28 md:h-40 bg-brand w-full relative overflow-hidden" data-id="element-97">
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(43,91,138,0.3)_0%,transparent_60%)]" data-id="element-98"></div>
      </div>

      {/* Profile Info */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-8" data-id="element-99">
        <div className="relative flex justify-between items-end -mt-16 md:-mt-20 mb-4" data-id="element-100">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} className="relative" data-id="element-101">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sarah Jenkins" className="w-32 h-32 md:w-40 md:h-40 rounded-full border-4 border-white shadow-lg object-cover bg-gray-100" data-id="element-102" />
            <div className="absolute bottom-2 right-2 w-4 h-4 bg-green-500 border-2 border-white rounded-full" title="Online" data-id="element-103"></div>
          </motion.div>

          <div className="hidden md:flex gap-3 pb-2" data-id="element-104">
            <a href="tel:+12485379200" className="flex items-center gap-2 bg-brand hover:bg-brand-dark text-white px-6 py-2.5 rounded-lg font-semibold transition-colors shadow-sm" data-id="element-105">
              <Phone className="w-4 h-4" data-id="element-106" />
              Call Sarah
            </a>
            <a href="mailto:sarah@rapidhomelending.com" className="flex items-center gap-2 bg-brand-dark hover:bg-brand text-white px-6 py-2.5 rounded-lg font-semibold transition-colors shadow-sm" data-id="element-107">
              <Mail className="w-4 h-4" data-id="element-108" />
              Send Email
            </a>
          </div>
        </div>

        <motion.div initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.1
      }} className="mt-2" data-id="element-109">
          <h1 className="text-2xl md:text-3xl font-bold text-brand" data-id="element-110">
            Sarah Jenkins
          </h1>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-1 text-gray-600" data-id="element-111">
            <span className="font-medium text-brand" data-id="element-112">Senior Loan Officer</span>
            <span className="hidden sm:inline text-gray-300" data-id="element-113">•</span>
            <span className="text-sm" data-id="element-114">NMLS #123456</span>
            <span className="hidden sm:inline text-gray-300" data-id="element-115">•</span>
            <span className="flex items-center gap-1 text-sm" data-id="element-116">
              <MapPin className="w-4 h-4" data-id="element-117" />
              Bingham Farms, MI
            </span>
          </div>

          <p className="mt-4 text-gray-600 max-w-2xl leading-relaxed" data-id="element-118">
            "15+ years helping families find their perfect home loan. I'm here
            to ensure your current mortgage continues to work for your financial
            goals."
          </p>

          {/* Mobile Actions */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6 md:hidden" data-id="element-119">
            <a href="tel:+12485379200" className="flex justify-center items-center gap-2 bg-brand hover:bg-brand-dark text-white px-6 py-3 rounded-lg font-semibold transition-colors shadow-sm w-full" data-id="element-120">
              <Phone className="w-5 h-5" data-id="element-121" />
              Call Sarah
            </a>
            <a href="mailto:sarah@rapidhomelending.com" className="flex justify-center items-center gap-2 bg-brand-dark hover:bg-brand text-white px-6 py-3 rounded-lg font-semibold transition-colors shadow-sm w-full" data-id="element-122">
              <Mail className="w-5 h-5" data-id="element-123" />
              Send Email
            </a>
          </div>
        </motion.div>
      </div>

      <div className="h-1 bg-brand/40" data-id="element-124"></div>
    </div>;
}